import { get, post, put, del } from "./ApiService";

const LABELS_ENDPOINT = "/labels";
const BUG_LABELS_ENDPOINT = "/bug_labels";

// Bir projeye ait etiketleri getirir
export const getLabels = async (projectId) => {
  const response = await get(LABELS_ENDPOINT, { project_id: projectId });
  return Array.isArray(response?.labels) ? response.labels : [];
};

// Yeni etiket oluşturur
export const createLabel = async ({ projectId, name, color } = {}) => {
  const response = await post(LABELS_ENDPOINT, {
    project_id: projectId,
    name,
    color,
  });

  if (response?.status === "error") {
    throw new Error(response?.message || "Etiket oluşturulamadı.");
  }

  return response;
};

// Etiketi günceller (isim ve/veya renk)
export const updateLabel = async ({ id, name, color } = {}) => {
  const response = await put(LABELS_ENDPOINT, { id, name, color });

  if (response?.status === "error") {
    throw new Error(response?.message || "Etiket güncellenemedi.");
  }

  return response;
};

// Etiketi siler
export const removeLabel = async ({ id } = {}) => {
  const response = await del(LABELS_ENDPOINT, { id });

  if (response?.status === "error") {
    throw new Error(response?.message || "Etiket silinemedi.");
  }

  return response;
};

// ---- Bug <-> Label ilişkisi ----

// Bir işe bağlı etiketleri getirir
export const getBugLabels = async (bugId) => {
  const response = await get(BUG_LABELS_ENDPOINT, { bug_id: bugId });
  return Array.isArray(response?.labels) ? response.labels : [];
};

// İşe etiket ekler
export const attachLabelToBug = async ({ bugId, labelId } = {}) => {
  const response = await post(BUG_LABELS_ENDPOINT, {
    bug_id: bugId,
    label_id: labelId,
  });

  if (response?.status === "error") {
    throw new Error(response?.message || "Etiket işe eklenemedi.");
  }

  return response;
};

// İşten etiketi kaldırır
export const detachLabelFromBug = async ({ bugId, labelId } = {}) => {
  const response = await del(BUG_LABELS_ENDPOINT, {
    bug_id: bugId,
    label_id: labelId,
  });

  if (response?.status === "error") {
    throw new Error(response?.message || "Etiket kaldırılamadı.");
  }

  return response;
};
